import SupportV2CategoryPage from 'pages/support-v2/support-v2-category-page';

export default function SupportCategoryDetail() {
  return <SupportV2CategoryPage />;
}
